import script from "./UploadBox.vue?vue&type=script&setup=true&lang=ts"
export * from "./UploadBox.vue?vue&type=script&setup=true&lang=ts"

import "./UploadBox.vue?vue&type=style&index=0&id=47277372&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-47277372"]])

export default __exports__